"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = buttonClasses;

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function buttonClasses(_ref) {
  var className = _ref.className,
      style = _ref.style,
      pristine = _ref.pristine,
      invalid = _ref.invalid,
      submitting = _ref.submitting;
  return (0, _classnames["default"])("button-".concat(style), {
    'is-disabled': pristine || invalid,
    'in-progress': submitting
  }, className);
}